module.exports = "/_next/static/images/6ab55457fb2c7b855c5ee60b4329c3c3-app-screenshots-md@2x.jpg";